import { createStore, createLogger } from 'vuex'
import Persistent from './plugins/persistent'

const debug = process.env.NODE_ENV !== 'production'
const files = require.context('./modules', false, /\.js$/)

let modules = {}
files.keys().forEach((c) => {
  const module = files(c).default
  // 提取文件名作为模块名（去掉"./"和扩展名）
  const moduleName = c.replace(/^\.\/(.*\/)?/, '').replace(/\.js$/, '')
  modules[moduleName] = module
})
// 配置持久化插件
const persistent = Persistent({
  key: 'vuex',
  modules: modules,
  modulesKeys: {
    local: Object.keys(modules),
    session: []
  }
})

export default createStore({
  modules: modules,
  strict: debug,
  plugins: debug ? [createLogger(), persistent] : [persistent]
})